import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MainModule } from './main/main.module';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { CorrelationInterceptor } from './core/interceptors/correlation.interceptor';
import { NgxParticlesModule } from '@tsparticles/angular';
import { MusculaErrorHandler } from './core/muscula-error-handler';
import { MusculaInterceptor } from './core/interceptors/muscula.interceptor';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  TranslateLoader,
  TranslateModule,
  TranslatePipe,
} from '@ngx-translate/core';
import { Constants } from './core/constants';
import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeUk from '@angular/common/locales/uk';

registerLocaleData(localeEn);
registerLocaleData(localeUk);

function HttpLoaderFactory(httpClient: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(httpClient);
}

const I18N_CONFIG = {
  defaultLanguage: Constants.DefaultLanguage,
  loader: {
    provide: TranslateLoader,
    useFactory: HttpLoaderFactory,
    deps: [HttpClient],
  },
};

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    TranslateModule.forRoot(I18N_CONFIG),
    NgbModule,
    NgxParticlesModule,
    MainModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CorrelationInterceptor, multi: true },
    // { provide: ErrorHandler, useClass: MusculaErrorHandler },
    // { provide: HTTP_INTERCEPTORS, useClass: MusculaInterceptor, multi: true },
    TranslatePipe,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
